import { render, staticRenderFns } from "./AppDataFilterCheckboxGroupItem.vue?vue&type=template&id=0cf704bf&"
import script from "./AppDataFilterCheckboxGroupItem.vue?vue&type=script&lang=js&"
export * from "./AppDataFilterCheckboxGroupItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports